module.exports = __webpack_public_path__ + "img/third_logo.8f8aaade.svg";